<div>

  <div [formGroup]="filtri">

    <!-- filtri iscritti -->
    <div class="flex flex-column align-items-center sm:flex-row mb-5 pt-5">

      <!-- filtri -->
      <div class="flex align-items-center justify-content-center mb-5 sm:mb-0">

        <!-- ricerca iscritti o altri elementi -->
        <div class="sm:mr-3">
          <span class="p-input-icon-left p-input-icon-right p-float-label">
            <i class="pi pi-search"></i>
            <input type="text" id="cercaSTP" class="shadow-4" pInputText formControlName="inserimento" />
            <label for="cercaSTP">Cerca STP</label>
            <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
          </span>
        </div>

      </div>

      <!-- <div>
        @if(xlsSpinner){
          <div class="pl-2 pr-2 pt-1">
            <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
          </div>
        }@else {
          <div class="bottoniStyle">
            <p-menu #menu [model]="vociStampa" [popup]="true" appendTo="body"></p-menu>

            <button
              pButton
              type="button"
              (click)="menu.toggle($event)"
              icon="pi pi-table"
              pTooltip="Stampe XLS"
              tooltipPosition="right"
              [disabled]="role_service.isConsultazioneRole()"
            ></button>
          </div>
        }

      </div> -->

    </div>

    <!-- avanzati -->
    <div class="flex align-items-center justify-content-center sm:justify-content-start mb-5 flex-wrap gap-3">

      <div class="sm:mb-0">
        <p-dropdown formControlName="situazione" [showClear]="true" [options]="statiDropdown" optionLabel="nome" placeholder="Situazione"></p-dropdown>
      </div>

      <!-- <div>
        <p-button label="Filtri Avanzati" icon="pi pi-filter" iconPos="right" class="filtriAvanzatiBtn mb-3 sm:mb-0" [badge]="numeroFiltriAvanzati.toString()" (click)="showFilters()"/>
      </div> -->

      <p-button
        class="clearFiltri"
        size="small"
        [outlined]="true"
        icon="pi pi-filter-slash"
        (click)="clearFilters()"
        pTooltip="Pulisci Filtri"
        tooltipPosition="right"
      />

    </div>

    <!-- @if(showAdvancedFilters){

      <div class="flex gap-3 border-round shadow-4 mb-5 p-3">

        <div class="flex flex-column">
          <p class="filtroAvanzatoLabelPrimo">Anno Morosità</p>
          <p class="filtroAvanzatoLabel">N° Anni Morosità</p>
        </div>

        <div class="flex flex-column gap-3">

          <div class="flex align-items-center">

            <div class="mr-3">
              <p-inputNumber inputId="annoDal" [useGrouping]="false" formControlName="annoDal" [minlength]="4" [maxlength]="4" placeholder="----" [showClear]="true" />
            </div>

            <p class="m-0 mr-3">al</p>

            <div class="mr-3">
              <p-inputNumber inputId="annoAl" [useGrouping]="false" formControlName="annoAl" [minlength]="4" [maxlength]="4" placeholder="----" [showClear]="true" />
            </div>

          </div>

          <div class="flex align-items-center">

            <div class="mr-3">
              <p-inputNumber inputId="numeroAnniDa" [useGrouping]="false" formControlName="numeroAnniDa" placeholder="--" [showClear]="true" />
            </div>

            <p class="m-0 mr-3">a</p>

            <div class="mr-3">
              <p-inputNumber inputId="numeroAnniAl" [useGrouping]="false" formControlName="numeroAnniAl" placeholder="--" [showClear]="true" />
            </div>

          </div>

        </div>

      </div>
    } -->

  </div>

  <div class="mb-5">

    <!-- PAGINATOR della tabella -->
    <div class="flex justify-content-start">
      <p-paginator
        [rows]="pageSize"
        [first]="currentPage"
        [rowsPerPageOptions]="[25, 100, 250, 500]"
        (onPageChange)="pageChange($event)"
        [totalRecords]="conteggio"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} di {totalRecords}"
        [showPageLinks]="false"
      >
      </p-paginator>
    </div>

  </div>

  <!-- tabella -->
  <div>
    <p-table
      #dt
      [value]="listaStpContab"
      [rowHover]="true"
      (onLazyLoad)="ordinamento($event)"
      [customSort]="true"
      [lazy]="true"
    >
      <!-- headers -->
      <ng-template pTemplate="header">
          <tr>
            @for(headerName of headersTabella; track $index){
              <th
                [pSortableColumn]="rowsTabella[$index]"
              >
                {{ headerName }}
                <p-sortIcon [field]="rowsTabella[$index]"></p-sortIcon>
              </th>
            }
          </tr>
      </ng-template>

      <!-- rows -->
      <ng-template pTemplate="body" let-stp>

          <tr style="cursor: pointer;" [routerLink]="generaRoutingLink(stp.id)">

            @for (rowName of rowsTabella; track $index) {

              @if (rowName === 'situazione') {
                <td class="font-bold" [style.color]="coloreStato(stp.situazione)">
                  {{ stp.situazione.toUpperCase() }}
                </td>
              }@else{
                <td>{{ stp[rowName] }}</td>
              }

            }
          </tr>
      </ng-template>
    </p-table>

  </div>

  <p-toast position="bottom-center"></p-toast>

</div>
